export const getInvoices = (state) => state.invoices
export const getContacts = (state) => state.contacts
export const getLoadedData = (state) => state.isDataLoaded
export const invoiceGroupCount = (state) => state.invoiceGroupCount
